var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileStick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02438 7.36842V9.45614C8.02438 10.6074 8.92436 11.5439 10.0307 11.5439C11.1371 11.5439 12.037 10.6074 12.037 9.45614V6.17544C12.037 3.86702 10.2428 2 8.02438 2C5.80595 2 4.01172 3.86702 4.01172 6.17544V9.75439C4.01172 11.7288 5.55373 13.3333 7.45114 13.3333",
    stroke: "#011533",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileStick);
export default __webpack_public_path__ + "static/media/file-stick.452d144b.svg";
export { ForwardRef as ReactComponent };